export function priceChanger(source, customerId, unitPriceElem, productElem, storeElem, qtyElem, afterChangeHook = null) {

	$.get("priceChanger.do", {
		source: source,
		customer: customerId,
		origPrice: unitPriceElem.value,
		product: productElem.value,
		store: storeElem.value,
		qtyItem: qtyElem.value

	}).done(data => {
		ajaxCallback(data, unitPriceElem, afterChangeHook);
	});
}

function ajaxCallback(str, unitPriceElem, afterChangeHook) {
	if (str !== null && str.length > 0) {
		const newPrice = parseInt(str);
		unitPriceElem.value = newPrice;
		unitPriceElem.style.background = '#FACC77';
	}
	if (typeof afterChangeHook === "function") afterChangeHook(str, unitPriceElem);
}